import trimString from './trimString';

export default function sanitizeTableValue(value: any) {
	if (typeof value === 'undefined' || value === null) return '_NONE_';
	else if (typeof value === 'boolean') {
		return value.toString();
	} else return trimString(String(value));
}
